import authApi from '@/api/auth';
import type { AuthResponse } from '@/types';

const getJWT = async (): Promise<AuthResponse> => {
  return authApi.post(`/refresh-token`);
};

export const getJWTQuery = { queryKey: ['auth'], queryFn: getJWT };
